// extracted by mini-css-extract-plugin
module.exports = {"fixed":"ButtonGroup_fixed__2WnM2"};